import { render, staticRenderFns } from "./user-edit-staff.vue?vue&type=template&id=71b2943c&scoped=true&"
import script from "./user-edit-staff.vue?vue&type=script&lang=js&"
export * from "./user-edit-staff.vue?vue&type=script&lang=js&"
import style0 from "./user-edit-staff.vue?vue&type=style&index=0&id=71b2943c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b2943c",
  null
  
)

export default component.exports